<!-- ═══════════════════════════════════════════════
     LANDING SECTIONS (new)
═══════════════════════════════════════════════ -->

<!-- HERO -->
<section class="lp-hero" id="home">
  <div class="hero-bg-shape s1"></div>
  <div class="hero-bg-shape s2"></div>
  <div class="hero-bg-shape s3"></div>

  <div class="hero-grid">
    <div class="hero-content">
      <div class="hero-badge">Whole Year Structured Learning & Assessments</div>
      <h1>Boost Your Child's <em>Year 4</em> Preparation</h1>
      <p>
        Carefully designed weekly tests covering Maths, English, Creative Writing, VR &amp; NVR —
        helping students build strong foundations early and develop steady academic confidence.
      </p>
      <div class="hero-btns">
        <a class="lp-btn-primary" (click)="scrollToCalendar()">Book Year 4 Topic Test</a>
        <a class="lp-btn-secondary" (click)="scrollToSubjects()">View Subjects ↓</a>
      </div>
    </div>

    <div class="hero-visual">
      <div class="hero-card">
        <h3>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
            style="vertical-align:-3px;margin-right:8px;color:var(--lp-gold)">
            <rect x="9" y="2" width="6" height="4" rx="1"/>
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
            <path d="M9 12h6M9 16h4"/>
          </svg>Subjects Covered
        </h3>

        <div class="subject-pill" *ngFor="let pill of heroPills">
          <div class="pill-icon" [style.background]="pill.bg" [innerHTML]="pill.svg"></div>
          <div class="pill-label">
            {{ pill.label }}
            <small>{{ pill.sub }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- STATS BAR -->
<div class="lp-stats">
  <div class="lp-stats-inner">
    <div class="lp-stat-item lp-reveal" *ngFor="let stat of lpStats">
      <div class="lp-stat-number">{{ stat.number }}<span>{{ stat.suffix }}</span></div>
      <div class="lp-stat-label">{{ stat.label }}</div>
    </div>
  </div>
</div>

<!-- SUBJECTS -->
<section class="lp-subjects" id="lp-subjects">
  <div class="lp-centered lp-reveal">
    <span class="lp-section-tag">What We Cover</span>
    <h2 class="lp-section-title">Step-by-Step Preparation for <em>Academic Success</em></h2>
    <p class="lp-section-sub">
      Our weekly Topic Tests are crafted to help Year 4 students gradually strengthen core skills and develop exam readiness.
    </p>
  </div>
  <div class="lp-subjects-grid">
    <div class="lp-subject-card lp-reveal" [ngClass]="subject.cls" *ngFor="let subject of lpSubjects">
      <span class="lp-s-icon" [innerHTML]="subject.svgPath"></span>
      <h3>{{ subject.title }}</h3>
      <p>{{ subject.desc }}</p>
    </div>
  </div>
</section>

<!-- FEATURES -->
<section class="lp-features" id="lp-features">
  <div class="lp-centered lp-reveal">
    <span class="lp-section-tag">How It Works</span>
    <h2 class="lp-section-title">Trusted by Parents, <em>Enjoyed by Students</em></h2>
    <p class="lp-section-sub">
      Our Year 4 Topic Tests are designed to make preparation structured, manageable and stress-free.
    </p>
  </div>
  <div class="lp-features-grid">
    <div class="lp-feature-card lp-reveal" *ngFor="let feature of lpFeatures">
      <div class="lp-feature-icon" [innerHTML]="feature.svg"></div>
      <h3>{{ feature.title }}</h3>
      <p>{{ feature.desc }}</p>
    </div>
  </div>
</section>

<!-- BENEFITS -->
<section class="lp-benefits" id="lp-benefits">
  <div class="lp-centered lp-reveal">
    <span class="lp-section-tag lp-benefits-tag">Your Advantage</span>
    <h2 class="lp-section-title lp-white">Your Year 4 Preparation, Organised</h2>
    <p class="lp-section-sub" style="color:rgba(255,255,255,.7)">
      Everything your child needs for a confident, well-prepared journey toward 11+ readiness.
    </p>
  </div>
  <div class="lp-benefits-grid">
    <div class="lp-benefit-item lp-reveal" *ngFor="let benefit of lpBenefits">
      <div class="lp-b-icon" [innerHTML]="benefit.svg"></div>
      <div>
        <h4>{{ benefit.title }}</h4>
        <p>{{ benefit.desc }}</p>
      </div>
    </div>
  </div>
</section>

<!-- STEPS -->
<section class="lp-steps" id="lp-steps">
  <div class="lp-centered lp-reveal">
    <span class="lp-section-tag">Get Started</span>
    <h2 class="lp-section-title">Ready in <em>3 Easy Steps</em></h2>
    <p class="lp-section-sub">Join hundreds of families already giving their children a structured head start.</p>
  </div>
  <div class="lp-steps-row">
    <div class="lp-step lp-reveal" *ngFor="let step of lpSteps">
      <div class="lp-step-num">{{ step.num }}</div>
      <h3>{{ step.title }}</h3>
      <p>{{ step.desc }}</p>
    </div>
  </div>
</section>

<!-- ═══════════════════════════════════════════════
     CALENDAR SECTION (existing — untouched)
═══════════════════════════════════════════════ -->

<section class="mock-calendar" id="calendar-section">
  <!-- FILTER TOOLBAR -->
  <div class="toolbar container-fluid">
    <div class="toolbar-row">
      <div class="toolbar-item">
        <label>Test Category</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.categoryId" (change)="setFilter()">
            <option [ngValue]="null">All</option>
            <option *ngFor="let cat of categories" [ngValue]="cat.category_id">
              {{ cat.category_name }}
            </option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <div class="toolbar-item">
        <label>Test Pattern</label>
        <div class="dropdown-like">
          <select [(ngModel)]="filters.pattern" (change)="setFilter()">
            <option [ngValue]="null">All</option>
            <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <div class="toolbar-item">
        <label>Face 2 Face / Online</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.mode" (change)="setFilter()">
            <option [ngValue]="null">Both</option>
            <option value="Online Session">Online</option>
            <option value="Classroom Session">Face to Face</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <div class="toolbar-item">
        <label>Months</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.month" (change)="setFilter()">
            <option [ngValue]="null">Any</option>
            <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <div class="toolbar-item">
        <label>Center</label>
        <div class="dropdown-like">
          <select class="form-select" [(ngModel)]="filters.center" (change)="setFilter()">
            <option [ngValue]="null">Any</option>
            <option *ngFor="let l of centers" [ngValue]="l">{{ l }}</option>
          </select>
          <span class="chev">▾</span>
        </div>
      </div>

      <div class="toolbar-item">
        <label>Reset Filters</label>
        <div class="dropdown-like">
          <Button class="reset-btn" (click)="resetAllFilters()">Reset</Button>
        </div>
      </div>
    </div>

    <div class="toolbar-item">
      <div class="dropdown-like">
        <Button class="ofr-cal-btn" [routerLink]="['/offer-free-resources']">Claim Offers</Button>
      </div>
    </div>

    <div class="search-item">
      <label>Search</label>
      <input
        type="text"
        class="form-control search-input"
        placeholder="Search name, location, category, type…"
        [(ngModel)]="filters.search"
      />
    </div>
  </div>

  <!-- LIST BODY -->
  <div class="test-card-listing-body container list-body">
    <ng-container *ngIf="testList && testList.length > 0; else nothingFound">
      <div
        class="session-card test-card"
        *ngFor="let t of testList"
        [class.mtc-row--active]="isRangeDate(t.test_date)"
      >
        <span class="hidden f-test-name">{{ t.test_name }}</span>
        <span class="hidden f-course-name">{{ t.course }}</span>
        <span class="hidden f-category-name">{{ t.category }}</span>
        <span class="hidden f-type-name">{{ t.type }}</span>
        <span class="hidden f-location-name" *ngIf="t && t.all_location">{{ t.all_location }}</span>
        <span class="hidden f-location-name" *ngIf="t && !t.all_location">{{ t.location }}</span>
        <span class="hidden f-fees">{{ t.payment_method }}</span>

        <!-- Date chip -->
        <div class="date-chip" [ngClass]="{ range: isRangeDate(t.test_date) }">
          <span>
            <ng-container *ngIf="t.exam_type === 'Online Session'">From <br /></ng-container>
            {{ trimChar(t.test_date, 11) }}
          </span>
        </div>

        <!-- Session Info -->
        <div class="session-info">
          <a class="session-title"
            [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
            {{ trimChar(t.category) }}
          </a>
          <a class="session-subtitle"
            [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
            {{ trimChar(t.type) }}
          </a>
          <a class="session-pattern"
            [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
            {{ t.test_name }}
          </a>
        </div>

        <!-- Badges -->
        <div class="badges">
          <span class="badge"
            [ngClass]="t && t.exam_type === 'Online Session' ? 'badge-online' : 'badge-ff'">
            {{ t && t.exam_type === "Online Session" ? "Online" : "Face to Face" }}
          </span>
          <span *ngIf="t && (t.location || t.all_location)" class="location-badge">
            <img src="assets/images/pin.png" alt="" />
            <span class="truncate" [title]="t.all_location || t.location">
              {{ trimChar(t.all_location || t.location) }}
            </span>
          </span>
        </div>

        <!-- Price -->
        <div class="price">
          <ng-container *ngIf="t.payment_method === 'Free'; else priced">Free</ng-container>
          <ng-template #priced>Price: £{{ t.test_fees }}</ng-template>
        </div>

        <!-- Book Button -->
        <div class="action">
          <a class="btn btn-book"
            [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
            Book
          </a>
        </div>
      </div>

      <!-- LOAD MORE -->
      <div class="text-center py-4 load-button" style="display: block">
        <button class="btn btn-load" (click)="loadMore(true)">Load More Sessions</button>
      </div>
    </ng-container>

    <ng-template #nothingFound>
      <div class="text-center py-5">No Session Found</div>
    </ng-template>
  </div>
</section>

<!-- ═══════════════════════════════════════════════
     FAQ SECTION (existing — untouched)
═══════════════════════════════════════════════ -->

<div class="faq-sc">
  <h4>FAQs</h4>

  <div class="drop-d">
    <details>
      <summary>How do I book my 11plus Mock Test?</summary>
      <div>
        <p>Select Center and Date on the 11plus Mock Test Calendar and Simply click "Book Now"</p>
      </div>
    </details>
    <details>
      <summary>Are these tests online or face-to-face?</summary>
      <div>
        <p>We offer both online &amp; offline mock tests.</p>
      </div>
    </details>
    <details>
      <summary>Which exam boards do you cover?</summary>
      <div>
        <p>GL, CSSE, FSCE, SET, ISEB – All covered!</p>
      </div>
    </details>
  </div>

  <h3 style="text-align: center; margin-top: 50px">
    Still have questions? <br />
    Connect Directly on
    <strong style="font-weight: bold">+44 7464772331</strong> &amp; EMAIL
    <strong style="font-weight: bold">academy&#64;sehyog.co.uk</strong>
  </h3>

  <div class="so-sc">
    <img src="assets/images/linkedin.png" alt="linkedin" />
    <img src="assets/images/facebook.png" alt="facebook" />
    <img src="assets/images/youtube copy.png" alt="youtube" />
    <img src="assets/images/twitter.png" alt="twitter" />
    <img src="assets/images/instagram.png" alt="instagram" />
  </div>

  <p style="width: 80%; margin-top: 100px; text-align: justify">
    SEHYOG is an educational institute dedicated to providing comprehensive
    support to KS2, 11plus, KS3, 11plus &amp; A-Level students to achieve excellence
    in education and personal development with honesty and transparency. The
    sessions, workshops/webinars conducted by SEHYOG do not guarantee 100%
    success in the real exams. No claim is made as to the accuracy or
    authenticity of the content of the sessions, workshops/webinars or the
    information shared via email, website, social media etc. SEHYOG or its
    volunteers/staff do not accept any liability to any person or firm for the
    information or advice (or the use of such information or advice) which is
    provided in the sessions/workshops, email or on social media. The
    information on the website, phone, emails, social media and
    sessions/workshops is provided on the basis that all persons accessing the
    information undertake responsibility for assessing the relevance and
    accuracy of its content.
  </p>
</div>